export default __webpack_public_path__ + "static/banner-b08da0a7d6c0614aa756610e3bd6c4a0.png";